import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const getEntityId = (entity) => {
  if (!entity) return null;
  if (typeof entity === "string") return entity;
  return entity.id || entity._id || null;
};

const EntityProfileLink = ({ type, entity, label, className = "" }) => {
  const id = getEntityId(entity);
  const display =
    label ||
    (typeof entity === "object" ? entity?.name || entity?.phone : null) ||
    "N/A";

  if (!id) {
    return <span className={className}>{display}</span>;
  }

  const path =
    type === "cafe"
      ? `/cafe/viewdetails/${id}`
      : `/user/viewdetails/${id}`;

  return (
    <Link
      to={path}
      className={`text-primary text-decoration-underline ${className}`}
      style={{ cursor: "pointer" }}
      onClick={(e) => e.stopPropagation()}
      aria-label={`View ${type} profile: ${display}`}
    >
      {display}
    </Link>
  );
};

EntityProfileLink.propTypes = {
  type: PropTypes.oneOf(["user", "cafe"]).isRequired,
  entity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      phone: PropTypes.string,
    }),
  ]),
  label: PropTypes.string,
  className: PropTypes.string,
};

export default EntityProfileLink;
